import './AddNames.css';
import { useState } from 'react';
import TablesNames from './TablesNames';
import AddNamesToNames from './AddNamesToNames';


export default function AddNames ({names, namesList, setNamesList, splitPassenger}) {
    const [openAddNames, setOpenAddNames] = useState(false);

    const addAllNames = () => {
        let dataNames = {}

        Object.keys(names).map((key) => {
            dataNames[key] = {name: `${names[key]['firstName']} ${names[key]['lastName']}`, dob: names[key]['dob'], credit: names[key]['credit']}
        })

        setNamesList(dataNames);
    }

    return (<>
        <div className='add-names-docket-head' >
            <p onClick={() => setOpenAddNames(true)} > הוסף / מחק </p>
            <p onClick={addAllNames}> הוסף הכל (<span> {Object.keys(names).length} </span>) </p>
        </div>

        <div className='add-names-docket-table'>
            <TablesNames namesList={namesList} splitPassenger={splitPassenger}/>
        </div>

        { openAddNames &&
        <AddNamesToNames 
        names={names}
        namesList={namesList}
        setNamesList={setNamesList}
        setClose={() => setOpenAddNames(false)}
        />}
    </>)
}